import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { getPaymentStatus, getRetryPaymentLink } from './../../../apis/nonAuth';
import { useSearchParams } from "react-router-dom";
import PaymentStatusLoader from './PaymentStatusLoader';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { encrypt } from './../../../utils/utils';
const PaymentStatus = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [loadPaymentLink, setLoadPaymentLink] = useState(false);
    const [transaction, setTransaction] = useState();
    useEffect(() => {
        handleGetPaymentStatus();
    }, []);
    const handleGetPaymentStatus = async () => {
        try {
            let chargeId = searchParams.get('tap_id');
            let data = {
                chargeToken: chargeId,
            }
            const res = await getPaymentStatus(data);
            setTransaction(res.data.transaction);
            setLoading(false);
        } catch (error) {
            console.log(error);

        }
    }

    const handleGetRetryPaymentLink = async () => {
        try {
            setLoadPaymentLink(true);
            let data = {
                order: await encrypt(transaction.reference.order),
            }
            const res = await getRetryPaymentLink(data);
            window.location.assign(res.data);
            setLoadPaymentLink(false);
        } catch (error) {
            console.log(error);
            setLoadPaymentLink(false);
        }
    }
    return (
        <div className="bg-slate-50 flex items-center justify-center px-4 py-10">
            {
                loading &&
                <PaymentStatusLoader />
            }
            {
                !loading &&
                <div className="w-full max-w-2xl bg-white rounded-3xl shadow-lg border border-slate-200 overflow-hidden">

                    {/* Header */}
                    <div className="bg-[#004040] p-10 text-center">
                        <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center mx-auto shadow-lg">
                            <svg
                                className="w-12 h-12 text-emerald-600"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2.5}
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>

                        <h1 className="text-4xl font-bold text-white mt-6">
                            {t('order_submitted')}
                        </h1>

                        <p className="text-emerald-100 mt-2 text-lg">
                            {t('order_submitted_msg')}
                        </p>
                    </div>
                    <div className="p-8">
                        {
                            transaction?.status !== "CAPTURED" &&
                            <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6">
                                <h2 className="text-xl font-semibold text-slate-800 mb-3">
                                    {t('payment_pending')}
                                </h2>

                                <p className="text-slate-600 leading-7">
                                    <span>{t('payment_not_confirmed')}</span>{" "}
                                    <span className="font-semibold text-slate-800">
                                        {t('dont_worry_you_can_retry_payment')}
                                    </span>
                                </p>

                                <p className="text-slate-600 mt-4">
                                    {t('payment_pending_text_2')}
                                </p>
                            </div>
                        }


                        {/* Order Details */}
                        <div className="mt-8 grid sm:grid-cols-2 gap-5">

                            <div className="bg-slate-100 rounded-xl p-5">
                                <p className="text-sm text-slate-500">
                                    {t('order_number')}
                                </p>
                                <p className="text-xl font-bold text-slate-900 mt-1">
                                    #ORD-{transaction.reference.order}
                                </p>
                            </div>

                            <div className="bg-slate-100 rounded-xl p-5">
                                <p className="text-sm text-slate-500">
                                    {t('payment_status_text')}
                                </p>
                                <span className="inline-flex mt-2 px-3 py-1 rounded-full bg-blue-800 text-slate-100 font-bold text-md">
                                    {transaction?.status}
                                </span>
                            </div>

                        </div>

                        {/* Buttons */}
                        <div className="mt-10 flex flex-wrap justify-center gap-4">
                            {
                                transaction?.status !== "CAPTURED" &&
                                <Button
                                    loading={loadPaymentLink}
                                    rounded
                                    label={t('retry_payment')}
                                    severity=""
                                    onClick={() => {
                                        handleGetRetryPaymentLink();
                                    }}
                                />
                            }

                            <Link
                                className="border rounded-full px-8 py-3"
                                to={'/shop'}
                                rounded
                                outlined
                            >{t('continue_shopping')}</Link>
                        </div>
                        <p className="text-center text-sm text-slate-500 mt-8">
                            {t('contact_support')}
                        </p>
                    </div>
                </div>
            }
        </div>
    );
};

export default PaymentStatus;